function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _excluded = ["eventKey", "disabled", "onClick", "active", "as"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { useContext } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import SelectableContext, { makeEventKey } from './SelectableContext';
import NavContext from './NavContext';
import Button from './Button';
import { dataAttr } from './DataKey';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Create a dropdown item. Returns a set of props for the dropdown item component
 * including an `onClick` handler that prevents selection when the item is disabled
 */

export function useDropdownItem(_ref2) {
  var key = _ref2.key,
      href = _ref2.href,
      active = _ref2.active,
      disabled = _ref2.disabled,
      onClick = _ref2.onClick;
  var onSelectCtx = useContext(SelectableContext);
  var navContext = useContext(NavContext);

  var _ref3 = navContext || {},
      activeKey = _ref3.activeKey;

  var eventKey = makeEventKey(key, href);
  var isActive = active == null && key != null ? makeEventKey(activeKey) === eventKey : active;
  var handleClick = useEventCallback(function (event) {
    if (disabled) return;
    onClick == null ? void 0 : onClick(event);

    if (onSelectCtx && !event.isPropagationStopped()) {
      onSelectCtx(eventKey, event);
    }
  });
  return [_defineProperty({
    onClick: handleClick,
    'aria-disabled': disabled || undefined,
    'aria-selected': isActive
  }, dataAttr('dropdown-item'), ''), {
    isActive: isActive
  }];
}
var DropdownItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var eventKey = _ref.eventKey,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      active = _ref.active,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? Button : _ref$as,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useDropdownItem = useDropdownItem({
    key: eventKey,
    href: props.href,
    disabled: disabled,
    onClick: onClick,
    active: active
  }),
      _useDropdownItem2 = _slicedToArray(_useDropdownItem, 1),
      dropdownItemProps = _useDropdownItem2[0];

  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    ref: ref
  }, dropdownItemProps));
});
DropdownItem.displayName = 'DropdownItem';
export default DropdownItem;